import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ec3ea38a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "color_999"
}, "提示：添加组织后可继续添加下一级组织", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_Org = _resolveComponent("Org");
  const _component_School = _resolveComponent("School");
  const _component_Eldialog = _resolveComponent("Eldialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createBlock(_component_Eldialog, _mergeProps(_ctx.$attrs, {
    visible: _ctx.show,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => _ctx.show = $event),
    title: '添加',
    onConfirmOk: _ctx.onConfirm,
    width: "508px"
  }), {
    form: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [false ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 0,
      style: {
        "text-align": "center",
        "margin-top": "10px",
        "width": "100%",
        "display": "block"
      },
      modelValue: _ctx.type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.type = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_button, {
        label: 0
      }, {
        default: _withCtx(() => [_createTextVNode("新增组织")]),
        _: 1
      }), false ? (_openBlock(), _createBlock(_component_el_radio_button, {
        key: 0,
        label: 1
      }, {
        default: _withCtx(() => [_createTextVNode("新增单位")]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["modelValue"])) : _createCommentVNode("", true), _hoisted_1, _withDirectives(_createVNode(_component_Org, {
      ref: "orgRef",
      onHandleSuccess: _ctx.handleSuccess,
      orgId: _ctx.orgId,
      activeOrg: _ctx.activeOrg
    }, null, 8, ["onHandleSuccess", "orgId", "activeOrg"]), [[_vShow, !_ctx.type]]), _withDirectives(_createVNode(_component_School, {
      ref: "schoolRef",
      onHandleSuccess: _ctx.handleSuccess,
      info: _ctx.schoolInfo,
      "onUpdate:info": _cache[1] || (_cache[1] = $event => _ctx.schoolInfo = $event),
      orgInfo: _ctx.orgInfo
    }, null, 8, ["onHandleSuccess", "info", "orgInfo"]), [[_vShow, _ctx.type]])])), [[_directive_loading, _ctx.loading]])]),
    footer: _withCtx(() => []),
    _: 1
  }, 16, ["visible", "onConfirmOk"]);
}